<p-dialog header="Огляд банківських транзакцій" [(visible)]="display" [modal]="true"
          [style]="{width: '90vw'}" (onHide)="onHideDialog()">

  <p-toolbar styleClass="mb-3">
    <ng-template pTemplate="left">
      <p-button label="Очікують" styleClass="mr-2" [outlined]="filter !== 'pending'" (onClick)="onFilterChange('pending')"></p-button>
      <p-button label="Проігноровані" styleClass="mr-2" [outlined]="filter !== 'ignored'" (onClick)="onFilterChange('ignored')"></p-button>
      <p-button label="Оброблені" [outlined]="filter !== 'processed'" (onClick)="onFilterChange('processed')"></p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <p-button icon="pi pi-refresh" label="Оновити" styleClass="p-button-success" (onClick)="loadList()"
                pTooltip="Оновити список" tooltipPosition="top"></p-button>
    </ng-template>
  </p-toolbar>

  <div *ngIf="recoveryRow" class="recovery-banner">
    <p>
      Платіж <strong>№{{recoveryPaymentDocumentId}}</strong> вже створено та збережено, але не вдалося
      зафіксувати це для транзакції від <strong>{{recoveryRow.counterparty_name}}</strong>
      ({{recoveryRow.amount_decimal | number:'1.2-2'}}).
      Документ реально існує — <a [routerLink]="['/edit-document', 9, recoveryPaymentDocumentId]">відкрити №{{recoveryPaymentDocumentId}}</a>.
      Створювати платіж повторно не потрібно.
    </p>
    <p-button label="Повторити фіксацію" icon="pi pi-refresh" styleClass="p-button-warning mr-2" (onClick)="retryRecovery()"></p-button>
    <p-button label="Закрити" icon="pi pi-times" styleClass="p-button-secondary" (onClick)="dismissRecovery()"></p-button>
  </div>

  <p-table [value]="items" [loading]="loading" dataKey="id" [rowHover]="true"
           [resizableColumns]="true"
           styleClass="p-datatable-gridlines p-datatable-striped agent-bank-payment-review-table">
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn style="width: 6.5rem">Дата</th>
        <th pResizableColumn style="width: 9rem">Наша компанія</th>
        <th pResizableColumn style="width: 13.5rem">Відправник</th>
        <th pResizableColumn style="width: 7rem; text-align: right">Сума</th>
        <th pResizableColumn style="width: auto">Призначення платежу</th>
        <th pResizableColumn style="width: 30rem; min-width: 25rem">Рахунок</th>
        <th pResizableColumn style="width: 20rem; min-width: 15rem">Дія</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{row.booking_date | date:'dd.MM.yyyy'}}</td>
        <td>{{row.our_entity_name}}</td>
        <td>
          <span [pTooltip]="row.counterparty_name" tooltipPosition="top" class="sender-preview">
            {{row.counterparty_name}}
          </span>
          <div class="CellComment" *ngIf="row.counterparty_edrpou">ЄДРПОУ: {{row.counterparty_edrpou}}</div>
        </td>
        <td style="text-align: right; white-space: nowrap;">{{row.amount_decimal | number:'1.2-2'}}</td>
        <td>
          <span [pTooltip]="row.remittance_text" tooltipPosition="top" class="remittance-preview">
            {{row.remittance_text}}
          </span>
          <div class="already-paid-warning" *ngIf="(filter === 'pending') && invoiceAlreadyPaid(row)">
            Рахунок вже повністю оплачено -- ймовірно, дублікат. Натисніть "Ігнорувати".
          </div>
        </td>
        <td>
          <ng-container *ngIf="filter === 'pending'; else readonlyInvoice">
            <div class="invoice-cell">
              <app-documentselector showLabel="false" placeholder="Оберіть рахунок..."
                                    [documentId]="row.selectedInvoiceId"
                                    [filterDocType]="1"
                                    [filterLcoClientId]="row.our_cliid"
                                    (selectedDocument)="onInvoiceSelected(row, $event)"></app-documentselector>
            </div>
            <div class="CellComment" *ngIf="row.matched_document_number">
              Пропозиція агента: №{{row.matched_document_number}} ({{row.match_confidence}})
            </div>
          </ng-container>
          <ng-template #readonlyInvoice>
            <span *ngIf="row.payment_document_number">Платіж №{{row.payment_document_number}}</span>
            <a *ngIf="!row.payment_document_number && row.overridden_document_number"
               [routerLink]="['/edit-document', 1, row.overridden_document_id]" target="_blank">
              Рахунок №{{row.overridden_document_number}}
            </a>
            <a *ngIf="!row.payment_document_number && !row.overridden_document_number && row.matched_document_number"
               [routerLink]="['/edit-document', 1, row.matched_document_id]" target="_blank">
              Рахунок №{{row.matched_document_number}}
            </a>
          </ng-template>
        </td>
        <td>
          <ng-container [ngSwitch]="filter">
            <ng-container *ngSwitchCase="'pending'">
              <p-splitButton label="Внести автоматично" icon="pi pi-bolt" severity="success" styleClass="mr-2"
                             [model]="row.actionItems" appendTo="body"
                             [disabled]="autoInFlight"
                             [buttonDisabled]="!row.selectedInvoiceId || invoiceAlreadyPaid(row)"
                             [tooltip]="autoTooltip(row)"
                             (onClick)="onPrimaryAction(row)"></p-splitButton>
              <p-button label="Ігнорувати" styleClass="p-button-secondary" [disabled]="autoInFlight" (onClick)="onIgnore(row)"></p-button>
            </ng-container>
            <ng-container *ngSwitchCase="'ignored'">
              <p-button label="Повернути в чергу" icon="pi pi-undo" styleClass="p-button-success" (onClick)="onReopen(row)"></p-button>
            </ng-container>
            <ng-container *ngSwitchCase="'processed'">
              <a *ngIf="row.payment_document_id" [routerLink]="['/edit-document', 9, row.payment_document_id]" target="_blank">
                Відкрити платіж №{{row.payment_document_number}}
              </a>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">
          {{ filter === 'pending' ? 'Немає транзакцій, що очікують обробки' : 'Немає рядків у цьому фільтрі' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<app-create-new-document
  *ngIf="paymentDialogVisible"
  [display]="paymentDialogVisible"
  [parentDocumentId]="paymentDialogParentDocumentId"
  [bankPaymentSeed]="paymentDialogSeed"
  header="Провести оплату"
  (displayChange)="onPaymentDialogDisplayChange($event)"
  (documentSaved)="onPaymentDocumentSaved($event)">
</app-create-new-document>

<app-agent-bank-payment-split
  *ngIf="splitVisible"
  [display]="splitVisible"
  [row]="splitRow"
  (displayChange)="onSplitDisplayChange($event)"
  (rowProcessed)="onSplitRowProcessed($event)"
  (recovery)="onSplitRecovery($event)">
</app-agent-bank-payment-split>
